export default function ClientTab() {
  return <p>Client details coming soon.</p>;
}
